import { render, staticRenderFns } from "./SourceOfResources.vue?vue&type=template&id=8001542e&scoped=true&"
import script from "./SourceOfResources.vue?vue&type=script&lang=ts&"
export * from "./SourceOfResources.vue?vue&type=script&lang=ts&"
import style0 from "./SourceOfResources.vue?vue&type=style&index=0&id=8001542e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8001542e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
